module.exports = __webpack_public_path__ + "static/media/globle-connection-img1.8e406fe6.png";